import '@babel/polyfill';
import { TweenMax, ScrollToPlugin } from "gsap/all";

function handleScrollSection() {
    const contactSection = document.querySelector('.footer-contact-section');
    const contactButton = document.querySelector('.contact-button');
    const bettingDirectorySection = document.querySelector('#betting-directory');
    const arrowButtonDown = document.querySelector('.arrow-button ');
    const scrollToContact = () => {
        const offset = contactSection.offsetTop;
        contactButton.addEventListener('click', () => {
            TweenMax.to(window, 1.2, {
                scrollTo: {
                  y: offset,
                  autoKill: true
                },
                lazy: false,
                ease: "Expo.easeInOut"
              });
        });
    }

    const scrollToNextSectionHandle = () => {
        const offset = bettingDirectorySection.offsetTop;
        arrowButtonDown.addEventListener('click', () => {
            TweenMax.to(window, 1.2, {
                scrollTo: {
                  y: offset,
                  autoKill: true
                },
                lazy: false,
                ease: "Expo.easeInOut"
              });
        });
    }

    scrollToContact();
    scrollToNextSectionHandle();
}

export default handleScrollSection;